import type { OAuthParams } from '@rentflowdev/api'
import { oauthApi } from '../api/client'
import { redirectWithCode } from './redirect'

export async function completeOtpAuthorization(
	identifier: string,
	code: string,
	params: OAuthParams,
): Promise<void> {
	const { accessToken } = await oauthApi.verifyOtp(identifier, code)

	await oauthApi.createSession(accessToken)
	const result = await oauthApi.postAuthorize(params)
	redirectWithCode(params, result)
}
